export const ROUTE_HOME_PAGE = '/homepage'
export const ROUTE_OLDPAPER = '/oldpaper'